import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ImageModel } from 'src/app/models/common/image.model';
import { ProductEditModel } from 'src/app/models/catalog/product-edit.model';
import { ApiService } from 'src/app/services/api.service';
import { BasePage } from '../base-page';
import { CategoryTreeItemModel } from 'src/app/models/catalog/category-tree-item.model';
import { ProductModificatorModel } from 'src/app/models/catalog/product-modificator.model';
import { MessageService } from 'src/app/services/message.service';

@Component({
    selector: 'app-edit-product',
    templateUrl: './edit-product.component.html',
    styleUrls: ['./edit-product.component.scss'],
    standalone: false
})
export class EditProductComponent extends BasePage implements OnInit {

  public categories: Array<CategoryTreeItemModel> = [];
  public model: ProductEditModel = { isPublished: true };
  public selectLinkCategory?: string = '';

  private flatCategories: Array<CategoryTreeItemModel> = [];

  public constructor(private mApiService: ApiService, private mRouter: Router, activatedRoute: ActivatedRoute, private mMessageService: MessageService) {
    super();
    this.model.id = activatedRoute.snapshot.params['id'] !== 'new' ? activatedRoute.snapshot.params['id'] : undefined;
  }

  ngOnInit(): void {

    if (this.model.id) {
      this.mApiService.get<ProductEditModel>(`/api/admin/catalog/product/edit/${this.model.id}`).subscribe({
        next: r => {
          this.model = r;
          this.isBusy = false;
        },
        error: () => {
          this.isBusy = false;
        }
      });
    } else {
      this.isBusy = false;
    }

    this.mApiService.get<Array<CategoryTreeItemModel>>('/api/admin/catalog/category/tree').subscribe(r => {
      this.categories = r;

      this.fillFlatListCat(this.categories);

      this.selectLinkCategory = undefined;
    });
  }

  public save() {
    this.isBusy = true;

    this.mApiService.post<ProductEditModel, ProductEditModel>('/api/admin/catalog/product/edit', this.model).subscribe({
      next: r => {
        this.isBusy = false;

        if (!this.model.id) {
          this.mRouter.navigate([`/products/edit/${r.id}`]);
        }

        this.model = r;

        this.mMessageService.addMessage({
          text: 'Продукт сохранён',
          type: this.mMessageService.types.success
        }, true);
      }, error: () => this.isBusy = false
    });
  }

  public selectFile(event: any) {
    if (!event.target.files[0]) {
      return;
    }

    const formData = new FormData();
    formData.append('file', event.target.files[0]);
    formData.append('order', '1');
    this.isBusy = true;

    this.mApiService.formData<ImageModel>('/api/admin/catalog/image/save', formData).subscribe({
      next: (r: ImageModel) => {
        if (!this.model.images) {
          this.model.images = [];
        }

        r.order = this.model.images.length + 1;

        this.model.images.push(r);
        this.isBusy = false;
      },
      error: () => this.isBusy = false
    });
  }

  public selectModificatorFile(modificator: ProductModificatorModel, event: any) {
    if (!event.target.files[0]) {
      return;
    }

    const formData = new FormData();
    formData.append('file', event.target.files[0]);
    formData.append('order', '1');
    this.isBusy = true;

    this.mApiService.formData<ImageModel>('/api/admin/catalog/image/save', formData).subscribe({
      next: (r) => {
        modificator.image = r;
        this.isBusy = false;
      },
      error: () => this.isBusy = false
    });
  }

  public removeModificatorImage(modificator: ProductModificatorModel) {
    modificator.image = undefined;
  }

  public getCategoryName(id: string) {
    return this.flatCategories.find(x => x.id == id)?.name;
  }

  public removeImage(image: ImageModel) {
    this.model.images?.splice(this.model.images?.indexOf(image), 1);
  }

  public addCategory() {
    if (!this.selectLinkCategory) {
      return;
    }

    if (!this.model.categoryIds) {
      this.model.categoryIds = [];
    }

    if (this.model.categoryIds.indexOf(this.selectLinkCategory ?? '') === -1) {
      this.model.categoryIds.push(this.selectLinkCategory ?? '');
    }

    this.selectLinkCategory = undefined;
  }

  public removeCategory(id: string) {
    this.model.categoryIds?.splice(this.model.categoryIds.indexOf(id), 1);
  }

  public getSelectPrefix(level: number) {
    return ' ' + '-'.repeat(level) + ' ';
  }

  public addModificator(modificator?: ProductModificatorModel) {

    if (!this.model.modificators) {
      this.model.modificators = [];
    }

    if (modificator) {
      if (!modificator.child) {
        modificator.child = [];
      }

      modificator.child.push({});
    } else {
      this.model.modificators.push({});
    }
  }

  public removeModificator(modificator: ProductModificatorModel) {
    if (!confirm('Вы действительно хотите удалить модификатор?')) {
      return;
    }

    const parent = this.getModificatorParent(modificator, this.model.modificators ?? []);

    if (parent) {
      parent.child?.splice(parent.child.indexOf(modificator), 1);
    }
    else {
      this.model.modificators?.splice(this.model.modificators.indexOf(modificator), 1);
    }
  }

  public override back(): void {
    this.mRouter.navigateByUrl('/products');
  }

  public moveImage(image: ImageModel, toLeft: boolean) {
    if (!this.model.images) {
      return;
    }

    let currentIndex = this.model.images.findIndex(x => x.id === image.id);

    let newIndex = currentIndex + (toLeft ? -1 : 1);

    if (newIndex < 0) {
      return;
    }

    if (newIndex >= this.model.images.length) {
      return;
    }

    const swap = this.model.images[newIndex];

    swap.order = currentIndex + 1;
    this.model.images[currentIndex].order = newIndex + 1;

    this.model.images[newIndex] = this.model.images[currentIndex];
    this.model.images[currentIndex] = swap;
  }


  private fillFlatListCat(cats: Array<CategoryTreeItemModel>) {
    for (let i = 0; i < cats.length; i++) {
      this.flatCategories.push(cats[i]);

      if (cats[i].categories?.length > 0) {
        this.fillFlatListCat(cats[i].categories);
      }
    }
  }

  private getModificatorParent(searchModificator: ProductModificatorModel, modificators: Array<ProductModificatorModel>) {

    if (!modificators) {
      return;
    }

    for (let i = 0; i < modificators.length; i++) {
      if (!modificators[i].child) {
        continue;
      }

      for (let j = 0; j < modificators[i].child!.length; j++) {

        if (modificators[i].child![j] == searchModificator) {
          return modificators[i];
        }
      }

      this.getModificatorParent(searchModificator, modificators[i].child ?? []);

    }

    return;

  }
}
